import * as i18nIsoCountries from 'i18n-iso-countries'
import latinize from 'latinize'
import _ from 'lodash'

import {beneluxCountriesCodes, euCountriesCodes, Locale} from '@/utils/constants'
import {
  highPriorityJurisdictions,
  Jurisdiction,
  lowPriorityJurisdictions,
  NotOfferedJurisdiction,
} from '@/utils/countries/constants'
import {alpha2ToName} from '@/utils/countries/translations'
import {AddressFragment} from '@/utils/graphqlSdk'
import {getLanguage} from '@/utils/i18n/language'
import {AddressSchema} from '@/utils/validations/common/address'

export const getCountriesAlpha2 = (): string[] => Object.keys(i18nIsoCountries.getAlpha2Codes())

export const getJurisdictionsAlpha2 = (): Jurisdiction[] => Object.values(Jurisdiction)

export const getAllJurisdictionsAlpha2 = (): string[] =>
  Object.keys({
    ..._.omit(i18nIsoCountries.getAlpha2Codes(), ['GB', ...beneluxCountriesCodes]),
    ...Jurisdiction,
    ...NotOfferedJurisdiction,
  })

export const normalizeJurisdictionName = (jurisdiction: string) =>
  latinize(jurisdiction.toLowerCase())

const jurisdictionsByPriority = [
  ...highPriorityJurisdictions,
  ..._.difference(_.values(Jurisdiction), highPriorityJurisdictions, lowPriorityJurisdictions),
  ...lowPriorityJurisdictions,
]

export const sortJurisdictionsByPriority = (jurisdictions: Jurisdiction[]) =>
  _.sortBy(jurisdictions, (jurisdiction) => _.indexOf(jurisdictionsByPriority, jurisdiction))

export const getFullAddressLink = (
  {street, postcode, city, country, state}: AddressFragment | AddressSchema,
  locale?: Locale,
) => {
  const language = getLanguage(locale ?? Locale.en)

  const countryByLanguage = alpha2ToName(country, language)

  const fullAddress = `${street}, ${city}${
    state ? `, ${state} ` : ' '
  }${postcode}, ${countryByLanguage}`

  return `https://google.com/search?q=${encodeURIComponent(fullAddress)}`
}

export const allJurisdictionAlpha2ByPriority = _.uniq([
  Jurisdiction.US,
  Jurisdiction.EU,
  Jurisdiction.UK,
  Jurisdiction.CA,
  Jurisdiction.CH,
  Jurisdiction.AU,
  Jurisdiction.NZ,
  Jurisdiction.CN,
  ...getAllJurisdictionsAlpha2(),
])

export const isMarketCovered = (disabledMarkets: Jurisdiction[] = [], key: Jurisdiction) =>
  _.includes(
    disabledMarkets.concat(
      disabledMarkets.includes(Jurisdiction.EU) ? (euCountriesCodes as Jurisdiction[]) : [],
    ),
    key,
  )
